import { render, staticRenderFns } from "./DialogSlot.vue?vue&type=template&id=03697a94&scoped=true&"
import script from "./DialogSlot.vue?vue&type=script&lang=js&"
export * from "./DialogSlot.vue?vue&type=script&lang=js&"
import style0 from "./DialogSlot.vue?vue&type=style&index=0&id=03697a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03697a94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03697a94')) {
      api.createRecord('03697a94', component.options)
    } else {
      api.reload('03697a94', component.options)
    }
    module.hot.accept("./DialogSlot.vue?vue&type=template&id=03697a94&scoped=true&", function () {
      api.rerender('03697a94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/DialogSlot.vue"
export default component.exports